export const tunnelRoutes: { [key: string]: string } = {
    summary: 'recapitulatif',
    signup: 'coordonnees',
    siren: 'siren',
    pto: 'logement',
    delivery: 'livraisons',
    payment: 'paiement',
    appointment: 'rendez-vous',
    redirect: 'redirect',
};
